<template>
    <PublishedReel :video="video"
                   :projectId="projectId"
                   :showClipList="showReelClips"
                   :autoplay="autoplay"
    />
</template>

<script>
    import PublishedReel from '@/components/VideoEditor/Player/PublishedReel'

    export default {
        components: {
            PublishedReel,
        },

        props: {
            video: { type: Object, required: true },
            autoplay: { type: Boolean, default: false },
            showReelClips: { type: Boolean, default: true },
        },

        computed: {
            projectId() {
                return this.video.reel_project_id;
            },
        },
    }
</script>